import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Install() {
  const navigate = useNavigate();
  const [canInstall, setCanInstall] = useState(!!window.deferredInstallPrompt);
  const [installed, setInstalled] = useState(false);

  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;

  useEffect(() => {
    const sync = () => setCanInstall(!!window.deferredInstallPrompt);
    const onInstalled = () => setInstalled(true);
    sync(); // catch an event that fired before this page mounted
    window.addEventListener("install-prompt-ready", sync);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("install-prompt-ready", sync);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const handleInstall = async () => {
    const promptEvent = window.deferredInstallPrompt;
    if (!promptEvent) return;
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    window.deferredInstallPrompt = null;
    setCanInstall(false);
    if (outcome === "accepted") setInstalled(true);
  };

  const box = { maxWidth: 420, margin: "60px auto", padding: 24, textAlign: "center" };

  if (isStandalone || installed) {
    return (
      <div style={box}>
        <h2>{installed ? "App installed " : "You're already using the app"}</h2>
        <button onClick={() => navigate("/")}>Open app</button>
      </div>
    );
  }

  return (
    <div style={box}>
      <h2>Install the app</h2>

      {isIOS ? (
        <p>
          On iPhone: open this page in <strong>Safari</strong>, tap the{" "}
          <strong>Share</strong> button, then choose{" "}
          <strong>Add to Home Screen</strong>.
        </p>
      ) : canInstall ? (
        <button onClick={handleInstall}>Install App</button>
      ) : (
        <p>
          Install isn't available yet. If you opened this link inside WhatsApp
          or another app, open it in <strong>Chrome</strong> instead. Otherwise
          use the browser menu and choose <strong>Install app</strong> or{" "}
          <strong>Add to Home screen</strong>.
        </p>
      )}
    </div>
  );
}

export default Install;